
<div style="padding-top: 20px;">
  <iframe allowtransparency="true"
          frameborder="0" scrolling="no"
          class="wistia_embed" name="wistia_embed" allowfullscreen mozallowfullscreen webkitallowfullscreen oallowfullscreen msallowfullscreen
          [src]="iframeUrl | safe" width="100%" height="800px"></iframe>
</div>
